// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.grid_si98U {
    display : grid;
    grid-template-columns: auto 1fr;
    column-gap : var( --size-padMedium, 16px );
    row-gap : var( --size-padMedium, 16px );
    align-items: center;
    justify-items: start;
    justify-content: left;
    padding : var( --size-padMedium, 16px );
  }
  
  .fill_dM1Rw {
    grid-column: 1 / span 2;
  }
  
  .sub_UOY9z {
    padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );
  }
  
  .pad_mhG2h {
    padding : var( --size-padLarge, 16px )
  }
  
  .hint_o72Ts {
    max-width: 300px;
    margin-bottom : var( --size-padLarge, 16px )
  }`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/map/renderers/Grid.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,+BAA+B;IAC/B,0CAA0C;IAC1C,uCAAuC;IACvC,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,uCAAuC;EACzC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qGAAqG;EACvG;;EAEA;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB;EACF","sourcesContent":["\n.grid {\n    display : grid;\n    grid-template-columns: auto 1fr;\n    column-gap : var( --size-padMedium, 16px );\n    row-gap : var( --size-padMedium, 16px );\n    align-items: center;\n    justify-items: start;\n    justify-content: left;\n    padding : var( --size-padMedium, 16px );\n  }\n  \n  .fill {\n    grid-column: 1 / span 2;\n  }\n  \n  .sub {\n    padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );\n  }\n  \n  .pad {\n    padding : var( --size-padLarge, 16px )\n  }\n  \n  .hint {\n    max-width: 300px;\n    margin-bottom : var( --size-padLarge, 16px )\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_si98U`,
	"fill": `fill_dM1Rw`,
	"sub": `sub_UOY9z`,
	"pad": `pad_mhG2h`,
	"hint": `hint_o72Ts`
};
export default ___CSS_LOADER_EXPORT___;
